import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CreditCard, ShieldCheck, BarChart3, RefreshCcw } from "lucide-react";

export default function CardPaymentsPage() {

  return (
    <div className="flex-1 space-y-4 p-4 md:p-6 pt-6">
      {/* Main Coming Soon Card */}
      <div className="flex items-center justify-center min-h-[60vh]">
        <Card className="max-w-2xl w-full">
          <CardHeader className="text-center space-y-4 pb-8">
            <div className="mx-auto h-20 w-20 rounded-full bg-primary/10 flex items-center justify-center">
              <CreditCard className="h-10 w-10 text-primary" />
            </div>
            <div className="space-y-2">
              <Badge variant="secondary" className="mb-2">
                Coming Soon
              </Badge>
              <CardTitle className="text-3xl">Card Payments</CardTitle>
              <CardDescription className="text-base">
                This feature is currently under development and will be available soon
              </CardDescription>
            </div>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="text-center space-y-2">
              <p className="text-muted-foreground">
                We're building a comprehensive card payment management system that will allow you to:
              </p>
            </div>

            {/* Feature Preview */}
            <div className="grid gap-4 md:grid-cols-2 pt-4">
              <div className="flex gap-3 p-4 rounded-lg border bg-card">
                <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <CreditCard className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Card Transaction Processing</h3>
                  <p className="text-sm text-muted-foreground">
                    Accept and process credit and debit card payments directly against outstanding invoices
                  </p>
                </div>
              </div>

              <div className="flex gap-3 p-4 rounded-lg border bg-card">
                <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <ShieldCheck className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Secure PCI Compliance</h3>
                  <p className="text-sm text-muted-foreground">
                    All card transactions handled securely in line with PCI DSS requirements
                  </p>
                </div>
              </div>

              <div className="flex gap-3 p-4 rounded-lg border bg-card">
                <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <RefreshCcw className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Automatic Reconciliation</h3>
                  <p className="text-sm text-muted-foreground">
                    Card payments automatically matched and allocated against customer accounts
                  </p>
                </div>
              </div>

              <div className="flex gap-3 p-4 rounded-lg border bg-card">
                <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <BarChart3 className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Transaction Reporting</h3>
                  <p className="text-sm text-muted-foreground">
                    Full visibility of card payment history with detailed reporting and export
                  </p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
